export function scrollToElement(elemnt, targetElementOffset, duretion = 500) {
    const frameTime = 16;
    let scrollTimes = Math.round(duretion / frameTime);
    let previousValue = elemnt.scrollTop;
    const scrollStep = Math.ceil((targetElementOffset - previousValue) / scrollTimes);

    const intervalIndex = setInterval(function() {
        previousValue += scrollStep;
        elemnt.scrollTop = previousValue;
        scrollTimes--;

        if (previousValue > elemnt.scrollTop || scrollTimes <= 1) {
            elemnt.scrollTop = targetElementOffset;
            clearInterval(intervalIndex);
        }
    }, frameTime);
}

export function getElementOffset(element) {
    const documentElement = document.documentElement;
    const elementBox = element.getBoundingClientRect();
    const top = elementBox.top + window.pageYOffset - documentElement.clientTop;
    const left = elementBox.left + window.pageXOffset - documentElement.clientLeft;

    return { top: top, left: left };
}

export function popupCenter(url, title, w, h) {
    const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    const dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    const newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}

export function getUrlParam(val) {
    let result = undefined;
    let tmp = [];
    
    location.search.replace('?', '').split('&').forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === val) result = decodeURIComponent(tmp[1]);
    });
    
    return result;
}


// WEBPACK FOOTER //
// ./src/services/layout.js